import React, { useState, useRef, useEffect  } from "react"
import MetaTags from 'react-meta-tags';
import {
  Row,
  Col,
  Card,
  Form,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Button
} from "reactstrap"
import Dropzone from "react-dropzone"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css"

const FileUpload = (props) => {

  const [selectedFiles, setSelectedFiles] = useState([])
  const [isGallery, setisGallery] = useState(false)
  const [photoIndex, setphotoIndex] = useState(0)

  useEffect(() => {
    if(props.initialFiles && props.initialFiles.length > 0){
      let initialFileArray = [];
      props.initialFiles.forEach(each => {
        //const file = new File(each,'tt')
        //console.log('file:'+file)
        //each.in
        initialFileArray.push({
          preview:each,
          formattedSize:'',
          name: each.substring(each.lastIndexOf("/")+1),
          path: each.substring(each.lastIndexOf("/")+1)
        })
      })
      setSelectedFiles(initialFileArray)
    }
  }, [props.initialFiles])

  useEffect(() => {
    if(props.reset > 0){
      setSelectedFiles([])
    }
  }, [props.reset])

  const removeFile = (name) => {
      const index = selectedFiles.findIndex(e => e.path === name);
      selectedFiles.splice(index, 1);
      setSelectedFiles([...selectedFiles]);
      props.onFileUploadValueChange([...selectedFiles])
  }

  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    let updatedList = [];
    selectedFiles.forEach(eachExistingFile => {
      const found = files.find(newFile => newFile.path === eachExistingFile.path)
      if(!found){
        updatedList.push(eachExistingFile)
      }
    })
    files.forEach(eachNewItem => updatedList.push(eachNewItem))
    //console.log('updatedList::'+JSON.stringify(updatedList))
    setSelectedFiles(updatedList)
    props.onFileUploadValueChange(updatedList)
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  return (
    <React.Fragment>
      <div className="">
        <Container fluid={true}>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Form>
                    <Dropzone
                      onDrop={acceptedFiles => {
                        handleAcceptedFiles(acceptedFiles)
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div
                            className="dz-message needsclick mt-2"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <div className="mb-3">
                              <i className="display-4 text-muted bx bxs-cloud-upload" />
                            </div>
                            <h4>Drop files here or click to upload.</h4>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <div className="dropzone-previews mt-3" id="file-previews">
                      {selectedFiles.map((f, i) => {
                        return (
                          <Card
                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                          >
                            <div className="p-2">
                              <Row className="align-items-center">
                                <Col className="col-auto">
                                  <img
                                    data-dz-thumbnail=""
                                    height="80"
                                    className="avatar-sm rounded bg-light"
                                    alt={f.name}
                                    src={f.preview}
                                  />
                                </Col>
                                <Col>
                                  <Link
                                    to="#"
                                    className="text-muted font-weight-bold"
                                    onClick={() => {
                                      setphotoIndex(i)
                                      setisGallery(true)
                                    }}
                                  >
                                    {f.name}
                                  </Link>
                                  <Button
                                    color="danger"
                                    className="btn btn-rounded btn-sm ms-2"
                                    onClick={() => {
                                      removeFile(f.name)
                                    }}
                                  >
                                    <i className="fas fa-trash-alt"></i> 
                                  </Button>
                                  <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                  </p>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        )
                      })}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {isGallery ? (
            <Lightbox
              mainSrc={selectedFiles[photoIndex].preview}
              nextSrc={selectedFiles[(photoIndex + 1) % selectedFiles.length].preview}
              prevSrc={selectedFiles[(photoIndex + selectedFiles.length - 1) % selectedFiles.length].preview}
              enableZoom={true}
              onCloseRequest={() => {
                setisGallery(false)
              }}
              onMovePrevRequest={() => {
                setphotoIndex((photoIndex + selectedFiles.length - 1) % selectedFiles.length)
              }}
              onMoveNextRequest={() => {
                setphotoIndex((photoIndex + 1) % selectedFiles.length)
              }}
              imageCaption={selectedFiles[photoIndex].name}
            />
          ) : null}

        </Container>
      </div>
    </React.Fragment>
  )
}

FileUpload.propTypes = {
  onFileUploadValueChange: PropTypes.func,
  initialFiles: PropTypes.array
}

export default FileUpload
